import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getUserPrivileges } from '@/api/auth'
import checkPermission from '@/utils/permission'
import $store from '@/store'

export class PriceAirPrivilegeUtils {
  // 实例集合
  static instanceMap = new Map()

  constructor() {
    this._isAdminOrHQ = MultiCompanyUtil.getInstance().isAdminOrHQ2('PriceAir')
    this._isShowTier = checkPermission(['PAT'])
    this._isInput = checkPermission(['PAI'])
    this._isApprove = checkPermission(['PAA'])
  }
  static async getInstance() {
    const userId = $store.getters.userId
    let instance = this.instanceMap.get(userId)
    if (!instance) {
      instance = new PriceAirPrivilegeUtils()
      this.instanceMap.set(userId, instance)
    }
    return instance
  }

  async getPOLPrivileges() {
    const airPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Airport)
    if (this._isAdminOrHQ) {
      return this.toPolAirPortMap(airPorts)
    }
    let pts = []
    if (!this._privileges) {
      await this.getPrivileges()
    }
    console.info('_privileges', this._privileges)
    if (this._privileges) {
      const polPrivileges = this._privileges.filter(privilege => this.filterAllPOL(privilege))
      console.info('polPrivileges', polPrivileges)
      if (polPrivileges && polPrivileges.length > 0) {
        for (const pg of polPrivileges) {
          if (pg.category === 'PALA') {
            return this.toPolAirPortMap(airPorts)
          }
          if (pg.category === 'PAL') {
            const ports = this.getPortByCode(airPorts, pg.shape.substr(2))
            pts = pts.concat(ports)
          }
        }
      }
    }
    return this.toPolAirPortMap(pts)
  }

  async getPrivileges() {
    await getUserPrivileges().then(res => {
      this._privileges = res.data
    })
  }

  toPolAirPortMap(pts = []) {
    const pgsLMap = {}
    if (!pts || pts.length === 0) {
      return pgsLMap
    }
    for (const pol of pts) {
      const code = pol.countryCode + pol.code
      pgsLMap[code] = this.pol2pg(code)
    }
    return pgsLMap
  }

  /**
   * 返回卸货港的运价权限
   */
  async getPODPrivileges() {
    const pgsDMap = {}
    let code = ''
    const airPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Airport)
    if (this._isAdminOrHQ) {
      for (const pod of airPorts) {
        code = pod.countryCode + pod.code
        pgsDMap[code] = this.pod2pg(code, '0')
      }
      return pgsDMap
    }
    let pts = []
    if (!this._privileges) {
      await this.getPrivileges()
    }
    if (this._privileges) {
      const podPrivileges = this._privileges.filter(privilege => this.filterAllPOD(privilege))
      if (podPrivileges && podPrivileges.length > 0) {
        for (const pg of podPrivileges) {
          pts = []
          if (pg.category === 'PAD') {
            const ports = this.getPortByCode(airPorts, pg.shape.substr(2))
            if (ports && ports.length > 0) {
              pts = pts.concat(ports)
            }
          } else if (pg.category === 'PADC') {
            const ports = this.getPortByCountry(airPorts, pg.shape)
            if (ports && ports.length > 0) {
              pts = pts.concat(ports)
            }
          } else if (pg.category === 'PADA') {
            pts = pts.concat(airPorts)
            if (pg.point === '0') {
              this.isAllPOD_0 = true
            }
          }
          for (const pod of pts) {
            code = pod.countryCode + pod.code
            if (pgsDMap.hasOwnProperty(code)) {
              if (Number(pgsDMap[code].point) > Number(pg.point)) { // 存储最小的等级
                pgsDMap[code] = this.pod2pg(code, pg.point)
              }
            } else {
              if (pg.point === '0' && !this._isShowTier) {
                /* 非企业内部员工，并且没有输入的权限，即使给了他0级运价权限，他也最多只能看1级运价，
                这是为了配合java后台，因为后台查询时会过滤这些不应看到的运价，
                若给了客户0级运价，这里若不作调整，后台会查询到0级运价，而不会查询出1级运价，
                然后后台过滤掉不应被看到的0级运价，造成客户连一级运价都看不到
                */
                pgsDMap[code] = this.pod2pg(code, '1')
              } else {
                pgsDMap[code] = this.pod2pg(code, pg.point)
              }
            }
          }
        }
      }
    }
    return pgsDMap
  }
  /**
   * 从pts中找出属于某一国家的港口
   */
  getPortByCountry(code, pts) { // 按照航线过滤港口
    const cyMap = {}
    for (const pt of pts) {
      if (!cyMap.hasOwnProperty(pt.countryCode)) {
        cyMap[pt.countryCode] = []
      }
      cyMap[pt.countryCode].push(pt)
    }
    if (cyMap && cyMap.hasOwnProperty(code)) {
      return cyMap[code]
    }
    return null
  }

  /**
   * 查询所有起运港限制
   */
  filterAllPOL(item) {
    return item.category.substr(0, 3) === 'PAL'
  }

  /**
   * 查询所有卸货港限制
   */
  filterAllPOD(item) {
    return item.category.substr(0, 3) === 'PAD'
  }

  pol2pg(countryCodeAndCode) {
    const pg = {}
    pg.category = 'PAL'
    pg.shape = countryCodeAndCode
    return pg
  }
  pod2pg(countryCodeAndCode, point) {
    const pg = {}
    pg.category = 'PAD'
    pg.shape = countryCodeAndCode
    pg.point = point
    return pg
  }
  /**
   * 根据code查找某一港口
   * @param code 港口三位码
   */
  getPortByCode(seaPorts = [], code) { // 按照航线过滤港口
    return seaPorts.filter(item => item.code === code)
  }

  /**
   * 根据权限返回可以查询的港口
   */
  getAirports(pgsMap, airPorts) {
    const pts = []
    if (!pgsMap || Object.keys(pgsMap).length === 0) {
      return pts
    }
    const fieldName = pgsMap
    const fieldNameSet = new Set()
    for (const q in fieldName) {
      // q 属性名称，value 对应的值
      fieldNameSet.add(q.substr(2)) // 去除前面两位国家码
    }
    for (const airPort of airPorts) {
      if (fieldNameSet.has(airPort.code)) {
        pts.push(airPort)
      }
    }
    return pts
  }

  async getAllAirPort() {
    return await getSpecificBasicData(basicCacheKeys.basic_data_Airport)
  }
  isAllPOD2(level) {
    const tiers = [0, 1, 2, 99]
    let rs = false
    for (const tier in tiers) {
      if (tier > level) break
      rs = checkPermission(['PADA_*_' + tier])
      if (rs) break
    }
    return rs
  }
  /**
   * 非管理员或总部的员工，在查询界面顶多只能看1级运价,需要自行判断isQuery=true
   */
  handlePODPriviledges(proxy, pgs) {
    if (proxy.isSameLevel) {
      if (proxy.level === 0) proxy.level = 1
    } else {
      if (pgs) {
        let tier = ''
        const len = pgs.length
        let pg = null
        proxy.isSameLevel = true
        for (let i = 0; i < len; i++) {
          pg = pgs[i]
          if (pg.point === '0') {
            pg = this.pod2pg(pg.shape, '1')
          }
          if (tier === pg.point) continue
          if (tier === '') {
            tier = pg.point
          } else {
            proxy.isSameLevel = false
          }
        }
      }
    }
  }

  get isShowTier() {
    return this._isShowTier
  }

  set isShowTier(value) {
    this._isShowTier = value
  }

  get isInput() {
    return this._isInput
  }

  set isInput(value) {
    this._isInput = value
  }

  get isApprove() {
    return this._isApprove
  }

  set isApprove(value) {
    this._isApprove = value
  }

  get isAdminOrHQ() {
    return this._isAdminOrHQ
  }

  set isAdminOrHQ(value) {
    this._isAdminOrHQ = value
  }

  get privileges() {
    return this._privileges
  }

  set privileges(value) {
    this._privileges = value
  }
}
